import React, { useState, useCallback } from 'react'
import {
  PieChart, Pie,
  Sector,
  Cell
} from "recharts";
import { LoadingSpinner } from '../Loader/Loader';

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
    name
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >{`${name} ${('defaultValue' in payload) ? payload.value : value}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

function PieChartDiv(props) {

  const { sectionTitle, sectionName, loading, dataSet, width, height, dataKey, dataKeyName, strokeColor, navClass, dataHasValue } = props


  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );

  return (
    <>
      {!loading ?
        <>
          {
            dataSet.length > 0 ?
              <PieChart width={400} height={400}>
                <Pie
                  activeIndex={activeIndex}
                  activeShape={renderActiveShape}
                  data={dataSet}
                  cx={200}
                  cy={200}
                  innerRadius={60}
                  outerRadius={80}
                  fill="rgb(206,162,82)"
                  dataKey={dataHasValue ? "value" : "defaultValue"}
                  onMouseEnter={onPieEnter}
                >
                  {
                    dataSet.map((cellData, index) => (
                      <Cell cursor="pointer" key={`pie-chart-index-${index}`} fill={cellData.background} />
                    ))
                  }
                </Pie>
              </PieChart>
              :
              <div className="d-flex justify-content-center align-items-center" style={{ height: 400 }}>
                <h4 className="text-secondary font-weight-light">No Data Found</h4>
              </div>
          }

        </>
        : (
          <div className="d-flex justify-content-center align-items-center" style={{ height: 400 }}>
            <LoadingSpinner />
          </div>
        )}
    </>
  )
}

export default PieChartDiv
